module.exports = __webpack_public_path__ + "img/live8.6981a73c.jpg";